export enum ContentDirection {
    LeftToRight = 1,
    RightToLeft = 2
}
